export const BEST_SELLERS_TEST_ID = 'home_best-sellers';
export const MIN_CARDS_TO_SHOWED = 4;
